// removed by extract-text-webpack-plugin
module.exports = {"popover":"_2jzZ8k"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReadAloudPopover/readAloudPopover-style.css
// module id = 290
// module chunks = 0